import axiosInstance from "../axios/axiosInstance";


export default class EnderecoService {

    getEnderecoPorCEP(cep) {
        return axiosInstance.get(`https://viacep.com.br/ws/${cep}/json/`)
    }

}
